import React from 'react'
import useCurrentUser from '../../../hooks/use-current-user'
import Unauthorized from '../../common/unauthorized'
import CreateButton from './create-button'
import PaginatedList from '../paginated-list'

const ReflectionPrompsScreen = () => {

    const { isAdmin } = useCurrentUser()

    if (!isAdmin) {
        return (<Unauthorized />)
    }

    return (
        <div style={{ padding: '20px'}}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Reflections</h1>
                <CreateButton />
            </div>
            <div>
                <PaginatedList />
            </div>
        </div>
    )
}

export default ReflectionPrompsScreen